import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PortalService } from '../../../../services/portal/portal.service';
import { Routes } from '../../../../../routes/routes';

@Component({
  selector: 'app-no-invested-funds-banner',
  templateUrl: './no-invested-funds-banner.component.html',
  styleUrls: ['./no-invested-funds-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoInvestedFundsBannerComponent {
  private portalService = inject(PortalService);
  private router = inject(Router);

  public isMemberPortal$ = this.portalService.isMember$;

  public goToAccounts(): void {
    this.router.navigate([Routes.accounts()]).then();
  }
}
